export default __webpack_public_path__ + "static/media/desktop.494df737.png";